import {formatPhoneNumber} from 'platform/locale';

import {TelephonyCall} from '@dms/api/settings';
import i18n from '@dms/i18n';

/** The customer's number as shown on the call; an inbound caller may withhold it. */
export const getCallPhoneNumberLabel = (call: TelephonyCall) =>
  formatPhoneNumber(call.customerPhoneNumber) ??
  call.customerPhoneNumber ??
  i18n.t('page.telephony.indicator.withheldNumber');
